export default __webpack_public_path__ + "static/media/sb-icon.52b2709f.webp";